module.exports = __webpack_public_path__ + "img/cover.223b4999.jpg";